// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { edgewareTestnet as _edgewareTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the edgewareTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 2022
 * Chain Name: Beresheet BereEVM Testnet
 * Default Block Explorer: https://testnet.edgscan.live
 * Default RPC URL: https://beresheet-evm.jelliedowl.net
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { edgewareTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: edgewareTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const edgewareTestnet = createCommon({
	..._edgewareTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
